<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/2DwA7t/tc-custom/9781429940955.jpg?1735615084680" alt="This image is the cover for the book Blackhorse Riders"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Blackhorse Riders
      </h1>
      <p class="bookDescription body article font2">
        <b>The true story of a US Army unit’s effort to rescue an outnumbered troop under heavy fire in Vietnam—and the thirty-nine-year odyssey to recognize their bravery.</b><br/><br/><b>Winner of the 2013 Silver Medal in History from the Military Writer’s Society of America</b><br/><br/><b>Finalist, 2013 Colby Award</b><br/><br/><b>Winner of the 2012 USA Best Book Award for Military History</b><br/><br/>Deep in the jungles of Vietnam, Alpha Troop, 1st Squadron, 11th Armored Cavalry, the famed Blackhorse Regiment, was a specialized cavalry outfit equipped with tanks and armored assault vehicles. On the morning of March 26, 1970, they began hearing radio calls from an infantry unit four kilometers away that had stumbled into a hidden North Vietnamese Army stronghold. Outnumbered at least six to one, the eighty-seven-man American company was quickly surrounded, pinned down, and fighting for its existence.<br/><br/>Captain John Poindexter, Alpha Troop’s twenty-five-year-old commander, realized that his outfit was the only hope for the trapped company. With the courage and determination that makes legends out of ordinary men, they effected a daring rescue and fought a pitched battle—at considerable cost. Many brave deeds were done that day, and Captain Poindexter tried to make sure his men were recognized for their actions.<br/><br/>Thirty years later, Poindexter was made aware that his award recommendations and even the records of the battle had somehow gone missing. Thus began the second phase of this remarkable story: a “battle” to ensure that his brave men’s accomplishments would never be forgotten again.<br/><br/><b>Praise for <i>Blackhorse Riders</i></b><br/><br/>“Keith’s compelling storytelling breathes life into the personalities involved, so that minute by minute, following both rescuers and rescued, you keep turning pages to find out who lives and who dies.” —Karl Marlantes, <i>New York Times</i>–bestselling author of<i> Matterhorn</i> and <i>What It Is Like to Go to War</i><br/><br/>“One of the finest and best-told combat stories to come out of Vietnam. . . . For those of us who were there, this is the kind of book we would be proud to pass on to our children.” —Nelson DeMille<br/><br/>“A definite must-read.” —<i>Booklist</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Philip Keith, George Casey
      </h2>
      
      <p class="authorDescription body article"><P>PHILIP KEITH became a naval aviator after graduating from Harvard. During three tours in Vietnam he was awarded, among other decorations, the Presidential Unit Citation, the Air Medal for Gallantry, the Purple Heart, and the Navy Commendation Medal. Keith is also a columnist for the <I>Southampton Press</I> and a feature writer for magazines. He lives in Southampton, Long Island.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?29307e6e